module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-second-white.7fd664d3.svg";